import { useI18n } from "@/lib/i18n";
import { useSite } from "@/lib/site";
import { mediaUrl, waLink } from "@/lib/api";
import { scrollToId } from "@/lib/lenis";
import { MessageCircle } from "lucide-react";

export const Footer = () => {
  const { t, L } = useI18n();
  const { data } = useSite();
  const s = data?.settings || {};

  return (
    <footer className="border-t border-gold/10 bg-ink" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            {s.hero_logo_path && (
              <img src={mediaUrl(s.hero_logo_path)} alt="Blackbeard Barbería" className="h-12 w-auto" />
            )}
          </div>
          <p className="font-mono text-[11px] tracking-[0.2em] text-mut uppercase">
            {L(s.tagline_es, s.tagline_en)}
          </p>
        </div>

        <div className="text-sm text-mut flex flex-col gap-2">
          {s.phone && (
            <a data-testid="footer-phone-link" href={`tel:${s.phone.replace(/\D/g, "")}`} className="hover:text-gold transition-colors">
              {s.phone}
            </a>
          )}
          {s.address && <span data-testid="footer-address">{s.address}</span>}
          {s.maps_url && (
            <a
              data-testid="footer-maps-link"
              href={s.maps_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gold transition-colors"
            >
              Google Maps
            </a>
          )}
          <span>
            {s.hours?.[0] ? `${L(s.hours[0].days_es, s.hours[0].days_en)} · ${s.hours[0].open}—${s.hours[0].close}` : ""}
          </span>
        </div>

        <div className="flex flex-col gap-2 text-sm md:items-end">
          <button data-testid="footer-home-link" onClick={() => scrollToId("#inicio")} className="text-mut hover:text-gold transition-colors md:text-right">
            {t("nav.home")}
          </button>
          <a data-testid="footer-whatsapp-link" href={waLink(s.whatsapp)} target="_blank" rel="noopener noreferrer" className="text-mut hover:text-gold transition-colors inline-flex items-center gap-2 md:justify-end">
            <MessageCircle size={14} /> WhatsApp
          </a>
          <a data-testid="footer-admin-link" href="/admin" className="text-mut/50 hover:text-gold transition-colors text-xs mt-4 md:text-right">
            {t("footer.admin_link")}
          </a>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center font-mono text-[10px] tracking-[0.2em] text-mut/50 uppercase">
        © {new Date().getFullYear()} {t("common.copyright_name")} — {t("footer.rights")}
      </div>
    </footer>
  );
};

export default Footer;
